import React from 'react';

const UrbanAngelsSection = () => {
  return (
    <section className="relative py-6 md:py-8 bg-ifys-light-gray overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-6">
          {/* Left: text content */}
          <div className="flex-1">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-4 md:mb-6 tracking-tight">
              Urban Angels Community Kitchen
            </h2>
            <div className="space-y-4 text-gray-700 text-base md:text-lg leading-relaxed">
              <p>
                UACK brings the community together to prepare nutritious frozen meals for those in need.
              </p>
              <p>
                While the meals offer immediate support during times of crisis, they also provide emotional comfort—reminding recipients they&apos;re not alone. Many have shared that this simple act of kindness has helped them begin to heal.
              </p>
              <p>
                Our program fosters connection on both sides. Volunteers not only contribute meaningfully but also build friendships, learn new skills, and strengthen their ties to the community.
              </p>
            </div>
          </div>

          {/* Right: Urban Angels donate graphic (PNG) */}
          <div className="flex-shrink-0 flex justify-center lg:justify-end">
            <a
              href="https://donorbox.org/uack"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Donate to Urban Angels Community Kitchen (opens in a new tab)"
              className="group relative block rounded-full transition-transform duration-300 hover:-translate-y-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-ifys-blue focus-visible:ring-offset-2"
            >
              <img
                src="/images/Urban Angels.png"
                alt="Urban Angels Community Kitchen — donate today and help us feed people in need"
                loading="lazy"
                className="w-56 h-56 sm:w-64 sm:h-64 md:w-72 md:h-72 object-contain"
              />
              <span
                aria-hidden="true"
                className="pointer-events-none absolute bottom-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 rounded-full bg-white/95 text-ifys-blue text-xs sm:text-sm font-semibold px-3 py-1.5 shadow ring-1 ring-gray-200 opacity-0 translate-y-1 transition-all duration-200 group-hover:opacity-100 group-hover:translate-y-0 group-focus-visible:opacity-100 group-focus-visible:translate-y-0 whitespace-nowrap"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
                Donate Here
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UrbanAngelsSection;
